<template>
  <div>
      <div class="row">
          <h4>Education History</h4>
      </div>
    <div class="row">
      <div class="col-md-12">
          <table class="table">
              <thead>
                  <th>Institute Name</th>
                  <th>Degree Name</th>
                  <th>Passing Year</th>
                  <th>Marks</th>
              </thead>
              <tbody>
                  <tr v-for="(education, index) in educations" :key="index">
                      <td>{{ education.InstituteName }}</td>
                      <td>{{ education.DegreeName }}</td>
                      <td>{{ education.PassingYear }}</td>
                      <td>{{ education.Marks }}</td>
                      <td>
                          <button class="btn btn-delete btn-sm"><i class="fa fa-times"></i></button>
                      </td>
                  </tr>
              </tbody>
          </table>
      </div>
      <div class="col-md-12">
        <form action="" method="post" @submit.prevent="postEmployeeEducations">
          <div class="card-body card-block">
            <div class="form-group">
              <label for="title" class="form-control-label">Degree Name</label>
              <input
                type="text"
                id="title"
                placeholder="Enter your degree name"
                class="form-control"
                name="title"
                v-model="DegreeName"
              />
            </div>

            <div class="row">
              <div class="col-6">
                <div class="form-group">
                  <label for="passing_year" class="form-control-label"
                    >Passing Year</label
                  >
                  <input
                    type="text"
                    id="passing_year"
                    placeholder="Enter Passing Year"
                    class="form-control"
                    name="passing_year"
                    v-model="PassingYear"
                  />
                </div>
              </div>
              <div class="col-6">
                <div class="form-group">
                  <label for="marks" class="form-control-label"
                    >Marks Percentage</label
                  >
                  <input
                    type="text"
                    id="postal-code"
                    placeholder="Enter Marks in Percentage"
                    class="form-control"
                    name="marks"
                    v-model="Marks"
                  />
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="institute" class="form-control-label"
                >Institute Name</label
              >
              <input
                type="text"
                id="institute"
                placeholder="Name of the Institute"
                class="form-control"
                name="institute"
                v-model="InstituteName"
              />
            </div>
            <div class="form-group">
              <input
                class="form-control btn btn-primary"
                type="submit"
                name="submit"
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props : ['EmployeeId',],
    data() {
        return {
            educations: null,
            DegreeName : '',
            InstituteName : '',
            Marks : '',
            PassingYear : '',
        }
    },
    methods:{
        getEmployeeEducations(id){
            axios
                .get("hr/employees/education/" + id)
                .then((response) => {
                    this.educations = response.data;
                })
                .catch((error) => {
                    this.errored = true;
                })
                .finally(() => (this.loader = false));
        },
        postEmployeeEducations(){
            var data = {
                'EmployeeId' : this.EmployeeId,
                'DegreeName' : this.DegreeName,
                'InstituteName' : this.InstituteName,
                'Marks' : this.Marks,
                'PassingYear' : this.PassingYear,
            }
            axios
                .post("hr/employees/education", data)
                .then((response) => {
                    console.log(response.data);
                })
                .catch((error) => {
                    this.errored = true;
                })
                .finally(() => (this.loader = false));
        }
    },
    mounted() {
        this.getEmployeeEducations(this.EmployeeId);
    },
};
</script>

<style lang="scss" scoped>
</style>
